import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';
import {ChapterNotification} from '../models/notification.model';

@Injectable({
    providedIn: 'root',
})
export class NotificationApiService {
    private apiUrl = `${API_URL}` + 'notifications';

    constructor(private http: HttpClient) {
    }

    // Admin CRUD
    create(notification: ChapterNotification): Observable<ChapterNotification> {
        return this.http.post<ChapterNotification>(this.apiUrl, notification);
    }

    update(notification: ChapterNotification): Observable<ChapterNotification> {
        return this.http.put<ChapterNotification>(this.apiUrl, notification);
    }

    delete(chapterId: string, notificationId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${chapterId}/${notificationId}`);
    }

    toggleActive(chapterId: string, notificationId: string, active: boolean): Observable<ChapterNotification> {
        return this.http.put<ChapterNotification>(
            `${this.apiUrl}/${chapterId}/${notificationId}/toggle?active=${active}`, null
        );
    }

    getByChapter(chapterId: string): Observable<ChapterNotification[]> {
        return this.http.get<ChapterNotification[]>(`${this.apiUrl}/chapter/${chapterId}`);
    }

    // User-facing
    getForUser(userId: string): Observable<ChapterNotification[]> {
        return this.http.get<ChapterNotification[]>(`${this.apiUrl}/user/${userId}`);
    }

    // Public (anonymous landing page) — no auth required
    getPublic(): Observable<ChapterNotification[]> {
        return this.http.get<ChapterNotification[]>(`${this.apiUrl}/public`);
    }

    dismiss(userId: string, notificationId: string): Observable<void> {
        return this.http.put<void>(`${this.apiUrl}/dismiss/${userId}/${notificationId}`, null);
    }
}
